import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import PortfolioBuilder from './pages/portfolio-builder';
import UniversityDirectory from './pages/university-directory';
import UniversityDiscover from './pages/university-discover';
import UniversityAnalyse from './pages/university-analyse';
import LoginRegister from './pages/login-register';
import WorkshopCatalog from './pages/workshop-catalog';
import WorkshopsEnrolled from './pages/workshops-enrolled';
import WorkshopAnnouncements from './pages/workshop-announcements';
import StudentDashboard from './pages/student-dashboard';
import UniGuideAI from './pages/uniguide-ai';
import AIOnboarding from './pages/ai-onboarding';
import AdminPanel from './pages/admin-panel';
import ResetPassword from './pages/reset-password';
import ProfileSettings from './pages/profile-settings';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
          {/* Define your route here */}
          <Route path="/" element={<LoginRegister />} />
          <Route path="/portfolio-builder" element={<PortfolioBuilder />} />
          <Route path="/university-directory" element={<UniversityDirectory />} />
          <Route path="/universities/discover" element={<UniversityDiscover />} />
          <Route path="/universities/analyse" element={<UniversityAnalyse />} />
          <Route path="/login-register" element={<LoginRegister />} />
          {/* provide /login alias to existing login-register page */}
          <Route path="/login" element={<LoginRegister />} />
          <Route path="/workshop-catalog" element={<WorkshopCatalog />} />
          <Route path="/workshops-enrolled" element={<WorkshopsEnrolled />} />
          <Route path="/workshop-announcements/:workshopId" element={<WorkshopAnnouncements />} />
          <Route path="/student-dashboard" element={<StudentDashboard />} />
          <Route path="/uniguide-ai" element={<UniGuideAI />} />
          <Route path="/ai-onboarding" element={<AIOnboarding />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/profile-settings" element={<ProfileSettings />} />
          <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;